module.exports = __webpack_public_path__ + "media/launchable-detail1_720p4.af5c2d9d.mp4";